/**
 * The clock-in timesheet's status vocabulary (System B `timesheets.status`),
 * as a label and a tone for the Clock In screen's shift pills.
 *
 * The CHECK constraint on `timesheets.status` allows exactly these five
 * (measured 2026-10-08). The pill used to print the raw value ("approved") and
 * paint every status that was not approved or rejected amber, so a value the
 * screen had never heard of read as "waiting on someone" — a claim about the
 * shift nobody made. An unknown status now gets a NEUTRAL tone, and its raw
 * value only as the last resort for a label.
 */
export type TimesheetStatusTone = 'ok' | 'bad' | 'wait' | 'neutral';

export const TIMESHEET_STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  approved: 'Approved',
  rejected: 'Rejected',
  locked: 'Locked',
};

const TONES: Record<string, TimesheetStatusTone> = {
  draft: 'wait',
  submitted: 'wait',
  approved: 'ok',
  rejected: 'bad',
  locked: 'wait',
};

/** The label for a status; an em dash when there is none; the raw value when unknown. */
export function timesheetStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  return TIMESHEET_STATUS_LABELS[status] ?? status;
}

/** The pill tone. Anything this file does not know is neutral, never amber. */
export function timesheetStatusTone(status: string | null | undefined): TimesheetStatusTone {
  return (status && TONES[status]) || 'neutral';
}
